import * as SurveyCore from 'survey-core';

// javascript for surveyjs library to override default behavior

export function returnMinutesByCookie(cookieName: string) {
  let minutes = 24 * 5 * 60; // default 5 days if exit cookie then only 8 hours
  if (cookieName === 'exit5m') minutes = 5;
  if (cookieName === 'exit10m') minutes = 10;
  if (cookieName === 'exit20m') minutes = 20;
  if (cookieName === 'exit1') minutes = 1 * 60;
  if (cookieName === 'exit4') minutes = 4 * 60;
  if (cookieName === 'exit8') minutes = 8 * 60;
  if (cookieName === 'exit24') minutes = 24 * 60;
  if (cookieName === 'exitm') minutes = 24 * 31 * 60;
  if (cookieName === 'exity') minutes = 24 * 365 * 60;
  if (cookieName === 'exitinfo') minutes = 720 * 60;
  if (cookieName === 'exit1s') minutes = 0.02;
  return minutes;
}

export function isCookieForExitInfo(cookieName: string) {
  const substrings = ['exit5m', 'exit10m', 'exit20m', 'exit1', 'exit4', 'exit24', 'exitm', 'exity', 'exitinfo', 'exit1s'];
  return substrings.some(v => cookieName.includes(v));
}

export function applyCookieBehavior() {
  function getExpireCookieString(cookieName: string) {
    const date = new Date();
    let minutes = returnMinutesByCookie(cookieName);
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    return 'expires=' + date.toUTCString();
  }

  // overwrite survey.js default cookie behaviour because a year is too long
  SurveyCore.SurveyModel.prototype.setCookie = function () {
    if (!this.cookieName || typeof document === 'undefined')
      return;
    let expires = getExpireCookieString(this.cookieName);
    document.cookie = this.cookieName + '=true; path=/; SameSite=None; Secure;' + expires;
    if (isCookieForExitInfo(this.cookieName)) {
      expires = getExpireCookieString('exitinfo'); // set also exitinfo for second call
      document.cookie = 'exitinfo=true; path=/; SameSite=None; Secure;' + expires;
    }
  };
}